import React, { Component } from "react";

import AppRouter from "./router";
import { AppContext, LoadingView } from "./components";

import "./App.scss";
import "./styles/reduction.scss";
import "./styles/wysiwyg.css";

class App extends Component {
    constructor(props) {
        super(props);

        this.showLoading = () => {
            this.setState({
                loading: true,
            });
        };
        this.hideLoading = () => {
            this.setState({
                loading: false,
            });
        };
        this.state = {
            loading: false,
            showLoading: this.showLoading,
            hideLoading: this.hideLoading,
        };
    }

    render() {
        return (
            <AppContext.Provider value={this.state}>
                <div className="App">
                    <AppRouter />
                </div>
                <LoadingView />
            </AppContext.Provider>
        );
    }
}

export default App;
